/* eslint-disable max-len */
import React, { useRef } from "react";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useOnClickOutside } from "../../CommonMethods/OutsideClick";
export default function Limit({limit,setLimit,handleNoOfRowsClick,isColumnSelect}){
    const limitArr=[15,30,50,100]
    const [isOpen,setIsOpen]=useState(false)
    const [searchParams]=useSearchParams()
    const ref=useRef()
    const buttonRef = useRef(null);
    const dropdownRef=useRef(null)
    useOnClickOutside(ref, () => {
        setIsOpen(false);
    });

 

    return(
        <>
            <div className="flex items-center" ref={ref}>
                <p className="text-sm font-semibold text-[#687182]">Rows per page:</p>
                <div className={`${isColumnSelect?`pl-1`:`relative pl-1`}`}>
                    <button  id="rows_per_page"  ref={buttonRef} onClick={()=>setIsOpen(!isOpen)} type="button" className="text-sm font-semibold text-[#687182] flex items-center">
                        <p>{searchParams?.get("limit")!==undefined?searchParams.get("limit"):limit}</p>
                        <span className="pl-0.5"><img id="rows_per_page" src="/images/down.svg" className={`${isOpen?"transform rotate-180":""}`} alt="icon" onClick={()=>setIsOpen(!isOpen)}/></span>
                    </button>
                    {/* <ul className="hidden">
                                        <li>
                                            <p>15</p>
                                        </li>
                                    </ul> */}
                    <ul className={`absolute top-[-140px] left-0 pl-1.5 py-1.5 pr-0.5 bg-white border border-white h-fit rounded-sm shadow-xl ${isOpen?"":"hidden"}`} ref={dropdownRef}  >
                        <li>
                            <ul className="max-h-[110px] overflow-auto pr-2 bg-white scrollbar_gray_thin">
                                {limitArr.map((item,index)=>(
                                    <li key={index}>
                                        <h1
                                            id={item}
                                            onClick={()=>{setLimit(item);setIsOpen(false);handleNoOfRowsClick(item)}}
                                            className={`text-base font-normal cursor-pointer ${item===parseInt(searchParams?.get('limit'))?'text-[#008586]':'text-[#00000]'} mb-[16px]`}
                                        >{item}</h1>
                                    </li>
                                ))}
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    )
   
}